import { Component, OnInit } from '@angular/core';
import { GeneralesProspecto } from '../../models/generales-prospecto';
import { CotizadorService } from '../../services/cotizador.service';
import { Prospecto } from '../../models/prospecto';

@Component({
  selector: 'app-generales-prospecto',
  templateUrl: './generales-prospecto.component.html',
  styleUrls: ['./generales-prospecto.component.scss']
})
export class GeneralesProspectoComponent implements OnInit {
  prospecto: GeneralesProspecto = { nombre: '', edad: '', genero: '', habito: '' };
  prospectObj: Prospecto;
  constructor(private cotizadorServcice: CotizadorService) { }

  ngOnInit(): void {

    
  /*  this.cotizadorServcice.getGeneralesProspecto().subscribe((prospecto) => {
      this.prospecto = prospecto;
    });*/
  }
}
